import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { _cmsEnterpriseFeatureIds, _cmsProfessionalFeatureIds, _marketingEnterpriseFeatureIds, _marketingFreeFeatureIds, _marketingProfessionalFeatureIds, _marketingStarterFeatureIds, _operationsFreeFeatureIds, _operationsProfessionalFeatureIds, _operationsStarterFeatureIds, _salesEnterpriseFeatureIds, _salesFreeFeatureIds, _salesProfessionalFeatureIds, _salesStarterFeatureIds, _serviceEnterpriseFeatureIds, _serviceFreeFeatureIds, _serviceProfessionalFeatureIds, _serviceStarterFeatureIds, _cmsStarterFeatureIds, _operationsEnterpriseFeatureIds, _cmsFreeFeatureIds } from 'self-service-api/constants/_MerchandiseFeatures';
const ProductFeaturesMap = {
  [MARKETING]: {
    [FREE]: _marketingFreeFeatureIds,
    [STARTER]: _marketingStarterFeatureIds,
    [PROFESSIONAL]: _marketingProfessionalFeatureIds,
    [ENTERPRISE]: _marketingEnterpriseFeatureIds
  },
  [SALES]: {
    [FREE]: _salesFreeFeatureIds,
    [STARTER]: _salesStarterFeatureIds,
    [PROFESSIONAL]: _salesProfessionalFeatureIds,
    [ENTERPRISE]: _salesEnterpriseFeatureIds
  },
  [SERVICE]: {
    [FREE]: _serviceFreeFeatureIds,
    [STARTER]: _serviceStarterFeatureIds,
    [PROFESSIONAL]: _serviceProfessionalFeatureIds,
    [ENTERPRISE]: _serviceEnterpriseFeatureIds
  },
  [CMS]: {
    [FREE]: _cmsFreeFeatureIds,
    [STARTER]: _cmsStarterFeatureIds,
    [PROFESSIONAL]: _cmsProfessionalFeatureIds,
    [ENTERPRISE]: _cmsEnterpriseFeatureIds
  },
  [OPERATIONS]: {
    [FREE]: _operationsFreeFeatureIds,
    [STARTER]: _operationsStarterFeatureIds,
    [PROFESSIONAL]: _operationsProfessionalFeatureIds,
    [ENTERPRISE]: _operationsEnterpriseFeatureIds
  }
};
export default ProductFeaturesMap;